const HBAR = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 0C4.47712 0 0 4.47712 0 10C0 15.5229 4.47712 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47712 15.5229 0 10 0Z"
      fill="black"
    />
    <path
      d="M14.0647 14.325H12.7948V11.625H7.20483V14.325H5.93484V5.57001H7.20483V8.20497H12.7948V5.57001H14.0648L14.0647 14.325ZM7.26483 10.615H12.8547V9.22001H7.26483V10.615Z"
      fill="white"
    />
  </svg>
);
export default HBAR;
